import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IonicModule} from "@ionic/angular";
import {PartnerSummaryComponent} from "./partner-summary.component";
import {EmailModule} from "../../../../../../components/common/email/email.module";
import {PhoneLabelModule} from "../../../../../common/phone/component/phone-label/phone-label.module";
import {AddressModule} from "../../../../../common/address/component/address/address.module";
import {AdditionalPropertyLabelModule} from "../../../../../common/additional-property/component/additional-property-label/additional-property-label.module";
import {SummaryModule} from "../../../../../core/component/summary/summary.module";
import {SummaryFieldModule} from "../../../../../core/component/summary-field/summary-field.module";
import {AgeLabelModule} from '../../../../../person/api/component/age-label/age-label.module';
import {
    PartnerSimilarPartnerSummaryModule
} from "../../../impl/component/partner-similar-partner-summary-field/partner-similar-partner.summary.module";
import {
    CommentSummaryFieldModule
} from "../../../../../core/component/comment/comment-summary-field/comment-summary-field.component";
import {
    TagsSummaryFieldComponent
} from "../../../../../common/tag/api/components/tags-summary-field/tags-summary-field.component";
import {DatetimeLabelModule} from "../../../../../core/component/date/datetime-label/datetime-label.module";
import {
    DatetimeSummaryFieldModule
} from "../../../../../core/component/date/datetime-summary-field/datetime-summary-field.module";
import {
    UserSummaryFieldModule
} from "../../../../../account/modules/user/api/component/user-summary-field/user-summary-field.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        PhoneLabelModule,
        EmailModule,
        AddressModule,
        AdditionalPropertyLabelModule,
        SummaryModule,
        SummaryFieldModule,
        AgeLabelModule,
        PartnerSimilarPartnerSummaryModule,
        CommentSummaryFieldModule,
        TagsSummaryFieldComponent,
        DatetimeLabelModule,
        DatetimeSummaryFieldModule,
        UserSummaryFieldModule,
    ],
    declarations: [
        PartnerSummaryComponent,
    ],
    exports: [
        PartnerSummaryComponent
    ],
})
export class PartnerSummaryModule{}
